import React, { FC, ReactNode, memo } from "react";

import Label from "@/components/atoms/inputForms/Label2";
import InputDate from "@/components/atoms/inputForms/InputDate";

interface Props {
  id?: string;
  name?: string;
  value?: Date;
  onChange?: (value: Date | null) => void;
  errors?: string[];
  label?: string;
  isLabelBorder?: boolean;
  isRequired?: boolean;
  className?: string;
  description?: string;
  placeholder?: string;
  hideCalendarIcon?: boolean;
}

const DateWithTopLabelBase: FC<Props> = ({
  className,
  onChange,
  value,
  label,
  isLabelBorder,
  errors,
  isRequired,
  description,
  placeholder,
  hideCalendarIcon,
}) => {
  const hasError = errors && errors.length > 0;

  const wrap = (children: ReactNode) =>
    label ? (
      <fieldset className={className}>
        <Label
          label={label}
          spBorder={isLabelBorder}
          isRequired={isRequired}
          classNames="mb-1"
          description={description}
        />
        {children}
      </fieldset>
    ) : (
      <div className={className}>{children}</div>
    );

  return wrap(
    <>
      <div className="flex gap-1 items-center">
        <InputDate
          selected={value}
          placeholder={placeholder}
          hideCalendarIcon={hideCalendarIcon}
          onChange={(value) => {
            onChange && onChange(value);
          }}
        />
      </div>
      {hasError && (
        <ul>
          {errors?.map((message, i) => (
            <li key={i} className="text-error-msg">
              {message}
            </li>
          ))}
        </ul>
      )}
    </>,
  );
};

export const InputDateField = memo(DateWithTopLabelBase);
